

import React, {useRef,useEffect,useState, useMemo } from 'react';
import { useParams ,useLocation} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import he from 'he';
import Skeleton from '../skelton';
import SocialShare from '../socialShare';
import { GoPencil } from "react-icons/go";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaRegClock } from "react-icons/fa6";
import { TiTick } from "react-icons/ti";
import { BsGraphUpArrow } from "react-icons/bs";
import { BiSolidFactory } from "react-icons/bi";
import { FaBriefcaseMedical } from "react-icons/fa6";
import { FaGlobeAmericas } from "react-icons/fa";
import { TbTargetArrow } from "react-icons/tb";
import { SiBookstack } from "react-icons/si";



const NewsContentMain =  ({ singleNews:ssrSingleNews,ssrContentId,ssrCatId,mobile }) => {
        
          const { contentText } = useParams();
          
          const [singleNews,setSingleNews]=useState(ssrSingleNews)
          const [loading,setLoading] = useState(false)
          const [error,setError]  = useState(null)
          const contentid = contentText.substring(contentText.lastIndexOf('-') + 1, contentText.lastIndexOf('.html'));
           const cut = contentText.substring(0, contentText.lastIndexOf('-'));
           const catid = cut.substring(cut.lastIndexOf('-') + 1);
           const contentIdRef=useRef(ssrContentId)
           const catIdRef=useRef(ssrCatId)
             const location = useLocation().pathname

          useEffect(() => {
            
    if (ssrSingleNews  &&  contentIdRef.current === contentid && catIdRef.current === catid ) {
              
               contentIdRef.current = contentid 
              catIdRef.current = catid 
                 setLoading(false)
               return;
    }

  


       setLoading(true)
      //  setNxtNews(null)
      //  setPrevNews(null)
       setSingleNews(null)

          
      const fetchData = async () => {
  try {
    const results = await Promise.allSettled([
      fetch(`https://www.teluguone.com/news_api/newsDetailedContentJson?catid=${catid}&contentid=${contentid}`),
      // fetch(`https://www.teluguone.com/news_api/newsDetailedPrevJson?catid=${catid}&contentid=${contentid}`),
      // fetch(`https://www.teluguone.com/news_api/newsDetailedNextJson?catid=${catid}&contentid=${contentid}`),
    ]);

    const safeJson = async r =>
      r.status === "fulfilled" && r.value.ok
        ? r.value.json().catch(() => null)
        : null;

    // const [mainJson, prevJson, nxtJson,moreJson] =
    const [mainJson] =
      await Promise.all(results.map(safeJson));

    setSingleNews(mainJson?.singlenews?.[0] || null);
    // setPrevNews(prevJson?.prvnews?.[0] || null);
    // setNxtNews(nxtJson?.nxtnews?.[0] || null);


  } catch (e) {
    console.error(e);
    setError(e.message)
  } finally {
    
    contentIdRef.current = contentid;
    catIdRef.current = catid;
    setLoading(false);

  }
};





             fetchData();
            

          }, [contentText]);
   

  const formatPubDate = (dateString) => {
  if (!dateString) return '';

  const match = dateString.match(
    /^([A-Za-z]{3}) (\d{1,2}), (\d{4}) (\d{1,2}):(\d{2})(AM|PM)$/i
  );

  if (!match) return dateString;

  const [, month, day, year, hour, minute, ampm] = match;

  const monthMap = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11
  };

  const date = new Date(
    Number(year),
    monthMap[month],
    Number(day),
    Number(hour) % 12 + (ampm.toUpperCase() === 'PM' ? 12 : 0),
    Number(minute)
  );

  const weekday = date.toLocaleDateString('en-US', {
    weekday: 'short'
  });

  return `${weekday} ${month} ${day}, ${year} ${hour}:${minute}${ampm.toUpperCase()}`;
};



  return (
       
        
     <>
      
       { singleNews &&  (
        <Helmet key={location}>
          <title>{he.decode(singleNews.title)}</title>
         
        </Helmet>
       )}

 
  

       <div className='news-content-main'>
                  {(loading) &&<div className='container-fluid'>
                                 <div className='row mt-5'>
                                     <div className='col-12'><Skeleton type={"title"} /></div>
                                     <div className='col-4'><Skeleton type={"paragraph"} /></div>
                      
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"news-content-square"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                     <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                               
                                 </div>
                                </div>
                  }


                 
                  {singleNews &&  catid !== '60' &&<div className={`news-content-main-one`}>
        <h1 className="news-content-main-one-heading" dangerouslySetInnerHTML={{ __html: he.decode(singleNews.title || 'No Title') }} />
        <p className="news-content-time notranslate" translate="no" >Published on: {formatPubDate(singleNews?.pub_date || '')}</p>
                    <GetTheFullDescContent data={singleNews?.fulldesc || 'No Content'} />

                   {singleNews?.fulldesc && <div className='w-100 d-flex justify-content-end mt-2 mb-5'> <SocialShare mobile={mobile} /> </div>}

        
                  </div>
                  }


                     {singleNews &&  catid === '60' &&<div className={`news-content-main-one`}>
        
                            <div className="article">

    <span className="cat-tag">Special Analysis</span>
    {/* వాస్తవ-ధృవీకరణ | ప్రత్యేక విశ్లేషణ */}

    <h1 className="headline">భారత్ గ్లోబల్ పవర్‌హౌస్‌గా ఎదుగుతోంది — అమెరికాలో రికార్డు $20.5 బిలియన్ పెట్టుబడులు</h1>

    <p className="sub-head">SelectUSA Investment Summit 2026లో భారత కంపెనీలు చరిత్ర సృష్టించాయి — STL నుండి Sun Pharma వరకు, భారత్ ఇప్పుడు కేవలం మార్కెట్ మాత్రమే కాదు, గ్లోబల్ ఇన్వెస్టర్‌గా రూపాంతరం చెందింది</p>

    <div className="byline">
      <span><GoPencil className='special-icon' /> ప్రత్యేక విశ్లేషకుడు</span>
      <span><FaRegCalendarAlt className='special-icon' /> మే 10, 2026</span>
      <span><FaRegClock className='special-icon' /> 8 నిమిషాల పఠనం</span>
      <span><TiTick className='special-icon' /> వాస్తవ-ధృవీకరణ చేయబడింది</span>
    </div>

    <div className="summary-box">
      <span className="box-label">Key Summary</span>
      మే 6, 2026న మేరీల్యాండ్‌లోని నేషనల్ హార్బర్‌లో జరిగిన <span>SelectUSA Investment Summit 2026</span>లో భారత కంపెనీలు అమెరికాలో రికార్డు స్థాయిలో <span>$20.5 బిలియన్ల పెట్టుబడులు</span> ప్రకటించాయి. ఔషధం, తయారీ, శక్తి మౌలిక సదుపాయాలు, సాంకేతికత రంగాలలో వ్యాపించిన ఈ పెట్టుబడులు — ఈ వేదికపై ఏ ఒక్క దేశం నుండి వచ్చిన <span>అతిపెద్ద ప్రకటన</span>. భారత-అమెరికా వ్యూహాత్మక ఆర్థిక భాగస్వామ్యంలో ఇది ఒక చారిత్రక మైలురాయి.
    </div>

    <h2 className="sec-head"><BsGraphUpArrow className='special-icon' /> అంకెల్లో చరిత్ర — రికార్డు సమ్మిట్</h2>

    <div className="stat-row">
      <div className="stat-card">
        <div className="stat-num">$20.5B</div>
        <div className="stat-lbl">మొత్తం భారత పెట్టుబడులు<br />(SelectUSA 2026)</div>
      </div>
      <div className="stat-card">
        <div className="stat-num">12</div>
        <div className="stat-lbl">పెట్టుబడి ప్రకటనలు చేసిన<br />భారత కంపెనీలు</div>
      </div>
      <div className="stat-card">
        <div className="stat-num">$1.1B+</div>
        <div className="stat-lbl">గ్రీన్‌ఫీల్డ్ &amp; విస్తరణ<br />ప్రాజెక్టులు</div>
      </div>
      <div className="stat-card">
        <div className="stat-num">$500B</div>
        <div className="stat-lbl">2030 నాటికి భారత-అమెరికా<br />వ్యాపార లక్ష్యం</div>
      </div>
    </div>

    <p className="body-para">అమెరికా రాయబారి సెర్జియో గోర్ ఈ సందర్భంగా మాట్లాడుతూ, "భారత్-అమెరికా ద్వైపాక్షిక వాణిజ్యాన్ని 2030 నాటికి $500 బిలియన్లకు రెట్టింపు చేసే లక్ష్యం వైపు ముందడుగు వేయడం నాకు గర్వంగా ఉంది" అని పేర్కొన్నారు. అమెరికా అండర్ సెక్రెటరీ విలియం కిమిట్ కూడా ఈ సమ్మిట్ భారత్ నుండి ఒకే రోజు అత్యధిక పెట్టుబడి ప్రకటనల రికార్డు అని నిర్ధారించారు.</p>

    <div className="pullquote">
      <p>"భారత్ ఇప్పుడు కేవలం మార్కెట్ మాత్రమే కాదు — ప్రపంచ పారిశ్రామిక శక్తిగా ఎదుగుతోంది. ప్రపంచంలో అతిపెద్ద ప్రజాస్వామ్యాలు వ్యాపారం చేసినప్పుడు, అందరూ గెలుస్తారు."</p>
      <cite>— US Ambassador Sergio Gor</cite>
    </div>

    <div className="divider"></div>

    <h2 className="sec-head"><BiSolidFactory className='special-icon' /> STL: AI మౌలిక సదుపాయాలకు $100 మిలియన్ పెట్టుబడి</h2>

    <p className="body-para">భారత్‌లో పురుడుపోసుకున్న ప్రముఖ కనెక్టివిటీ పరిష్కారాల సంస్థ <span>Sterlite Technologies Ltd. (STL)</span> — SelectUSA సమ్మిట్ 2026లో అమెరికాలో <span>$100 మిలియన్ల (దాదాపు ₹835 కోట్లు)</span> పెట్టుబడి ప్రకటించింది. ఈ పెట్టుబడి ప్రధానంగా AI డేటా సెంటర్లు మరియు టెలికాం కస్టమర్లకు అవసరమైన ఆప్టికల్ ఫైబర్ కేబుల్స్ తయారీ సామర్థ్యాన్ని పెంచడానికి ఉపయోగపడుతుంది.</p>

    <div className="detail-box">
      <span className="box-label">STL పెట్టుబడి వివరాలు</span>
      <ul>
        <li>పెట్టుబడి మొత్తం: <span>$100 మిలియన్లు</span></li>
        <li>సృష్టించే ఉద్యోగాలు: <span>400–500</span></li>
        <li>ప్రధాన ఉత్పత్తి: Terminated Optical Fiber Cables</li>
        <li>సేవలందించే రంగాలు: AI Data Centers, Telecom</li>
        <li>ప్రత్యేక ఉత్పత్తి: Celesta 6912 Fiber Cable</li>
        <li>CEO: రాహుల్ పూరి — గ్లాస్ తయారీ నుండి డేటా సెంటర్ కనెక్టివిటీ వరకు వాల్యూ చెయిన్ నియంత్రణ</li>
      </ul>
    </div>

    <p className="body-para">AI వర్క్‌లోడ్లు మరియు GPU-ఇంటెన్సివ్ డేటా సెంటర్ వ్యవస్థలు విస్తరిస్తున్న నేపథ్యంలో హైస్పీడ్ ఫైబర్ మౌలిక సదుపాయాలకు డిమాండ్ తీవ్రంగా పెరుగుతోంది. STL ఇప్పటికే అమెరికాలోని ప్రధాన కస్టమర్లతో ఒప్పందాలు కుదుర్చుకుంది.</p>

    <div className="divider"></div>

    <h2 className="sec-head"><FaBriefcaseMedical className='special-icon' /> Sun Pharma: భారత ఔషధ చరిత్రలో అతిపెద్ద విదేశీ సంపాదన</h2>

    <p className="body-para">ఏప్రిల్ 27, 2026న భారత్ ఔషధ రంగంలో అతిపెద్ద అంతర్జాతీయ సంపాదన జరిగింది. <span>Sun Pharmaceutical Industries</span> న్యూజెర్సీ ఆధారిత <span>Organon &amp; Co.</span>ను <span>$11.75 బిలియన్ల (దాదాపు ₹98,000 కోట్లు)</span> అన్ని నగదు లావాదేవీలో కొనుగోలు చేయడానికి ఒప్పందం కుదుర్చుకుంది. ఆర్గనాన్ వాటాదారులకు షేరుకు $14 నగదు లభిస్తుంది.</p>

    <div className="summary-box">
      <span className="box-label">Sun Pharma - Organon డీల్ కీలక వివరాలు</span>
      అర్హత: భారత ఔషధ కంపెనీ చేసిన అతిపెద్ద విదేశీ సంపాదన &nbsp;|&nbsp; ఒప్పంద విలువ: <span>$11.75B</span> &nbsp;|&nbsp; ముగింపు: 2027 ప్రారంభంలో (నియంత్రణ అనుమతులతో) &nbsp;|&nbsp; ఇరు కంపెనీల బోర్డులు ఆమోదించాయి
    </div>

    <div className="divider"></div>

    <h2 className="sec-head"><FaGlobeAmericas   className='special-icon' /> SelectUSA 2026లో ఇతర భారత కంపెనీల పెట్టుబడులు</h2>

    <p className="body-para">US ఎంబసీ ఫ్యాక్ట్‌షీట్ ప్రకారం, 12 భారత కంపెనీలు మొత్తం $1.1 బిలియన్ పైగా పెట్టుబడులు ప్రకటించాయి:</p>

    <table className="invest-table">
      <thead>
        <tr>
          <th>కంపెనీ</th>
          <th>పెట్టుబడి</th>
          <th>రంగం</th>
          <th>ఉద్యోగాలు</th>
        </tr>
      </thead>
    <tbody>
        <tr>
          <td><span>Sterlite Technologies (STL)</span></td>
          <td>$100 మిలియన్</td>
          <td><span className="badge badge-blue">AI / టెలికాం</span></td>
          <td>400–500</td>
        </tr>
        <tr>
          <td><span>Abhyuday Group</span></td>
          <td>$900 మిలియన్+</td>
          <td><span className="badge badge-green">తయారీ</span></td>
          <td>1,500</td>
        </tr>
        <tr>
          <td><span>JSW Steel</span></td>
          <td>$255 మిలియన్</td>
          <td><span className="badge badge-green">స్టీల్/తయారీ</span></td>
          <td>ఒహియో, టెక్సాస్</td>
        </tr>
        <tr>
          <td><span>Jindal Pipe / Jindal Tubular USA</span></td>
          <td>$87 మిలియన్</td>
          <td><span className="badge badge-green">తయారీ</span></td>
          <td>140</td>
        </tr>
        <tr>
          <td><span>Jivo Wellness</span></td>
          <td>$15 మిలియన్</td>
          <td><span className="badge badge-amber">ఆరోగ్యం</span></td>
          <td>50 ప్రత్యక్ష + 150 పరోక్ష</td>
        </tr>
        <tr>
          <td><span>RoshAi</span></td>
          <td>$5 మిలియన్</td>
          <td><span className="badge badge-blue">AI / సాంకేతికత</span></td>
          <td>20 (టెక్సాస్)</td>
        </tr>
        <tr>
          <td><span>Techdome Solutions</span></td>
          <td>$7.5 మిలియన్</td>
          <td><span className="badge badge-blue">సాంకేతికత</span></td>
          <td>100</td>
        </tr>
        <tr>
          <td><span>Atri AI</span></td>
          <td>$2 మిలియన్</td>
          <td><span className="badge badge-blue">AI</span></td>
          <td>మెన్లో పార్క్, కాలిఫోర్నియా</td>
        </tr>
        <tr>
          <td>
            <span>ఔషధ రంగం మొత్తం</span><br />
            <small style={{color:"#888",fontSize:"12px"}}>(Sun Pharma, Aurobindo, Biocon, Cipla, Dr.Reddy's, Lupin, Piramal, Zydus...)</small>
          </td>
          <td><span>$19.1 బిలియన్+</span></td>
          <td><span className="badge badge-red">ఔషధం</span></td>
          <td>వేల ఉద్యోగాలు</td>
        </tr>
      </tbody>
    </table>

    <div className="divider"></div>

    <h2 className="sec-head">వాస్తవ-పరిశీలన: ఏది నిజం, ఏది అతిశయోక్తి?</h2>

    <div className="fact-box">
      <h4><TiTick /> ధృవీకరించబడిన వాస్తవాలు</h4>
      <ul>
        <li>STL $100 మిలియన్ US పెట్టుబడి — <span>నిజం</span>. PRNewswire, BusinessWorld ధృవీకరించాయి.</li>
        <li>Sun Pharma - Organon $11.75B డీల్ — <span>నిజం</span>. SEC filing, Organon అధికారిక ప్రకటన ధృవీకరించింది.</li>
        <li>$20.5 బిలియన్ మొత్తం పెట్టుబడులు — <span>నిజం</span>. US ఎంబసీ ఇండియా అధికారిక ప్రకటన.</li>
        <li>12 కంపెనీలు $1.1B గ్రీన్‌ఫీల్డ్ పెట్టుబడులు — <span>నిజం</span>. US Commerce Dept. ధృవీకరించింది.</li>
      </ul>
    </div>

    <div className="fact-box">
      <h4>⚠️ ధృవీకరించవలసిన అంశాలు (నవీనతమ సమాచారం లేదు)</h4>
      <ul>
        <li><span>Tata Motors - Iveco $4.4B డీల్</span>: ఈ ఒప్పంద వివరాలు ప్రస్తుత శోధనల్లో ధృవీకరించబడలేదు — జాగ్రత్తగా రిపోర్ట్ చేయాలి.</li>
        <li><span>Arvind Limited - Dalco-GFT $136M</span>: ధృవీకరణ అవసరం.</li>
        <li><span>Reliance Industries Texas రిఫైనరీ $300B</span>: ఈ పెద్ద మొత్తం నిర్ధారించే వివరాలు లేవు.</li>
        <li><span>Mazagon Dock - Colombo Dockyard</span>: విస్తరణ వార్తలు ఉన్నా వివరాలు ధృవీకరించాలి.</li>
      </ul>
    </div>

    <div className="divider"></div>

    <h2 className="sec-head"><BsGraphUpArrow className='special-icon' /> వ్యూహాత్మక విశ్లేషణ: భారత్ మారుతున్న వ్యాపార స్వభావం</h2>

    <p className="body-para">దశాబ్దాల తరబడి భారత్ విదేశీ పెట్టుబడులు స్వీకరించే మార్కెట్‌గా మాత్రమే ఉండేది. కానీ SelectUSA 2026 సమ్మిట్ చూపించింది — భారత కంపెనీలు ఇప్పుడు ప్రపంచంలో అత్యంత పోటీతత్వమైన మార్కెట్ అయిన అమెరికాలో బిలియన్ డాలర్ పెట్టుబడులు పెట్టగల సామర్థ్యానికి ఎదిగాయి.</p>

    <p className="body-para">ఔషధ రంగంలో $19.1 బిలియన్ పెట్టుబడులు (మొత్తంలో 93%) ప్రముఖంగా ఉన్నాయి. Sun Pharma యొక్క Organon సంపాదన ఒక్కటే ఈ స్థాయికి ముఖ్యమైన కారణం. అయినప్పటికీ, AI, తయారీ, ఇంధనం రంగాల్లో కూడా గణనీయమైన ప్రకటనలు జరిగాయి — ఇది భారత్ ఆర్థిక ప్రపంచీకరణ వైవిధ్యాన్ని చూపుతోంది.</p>

    <div className="detail-box">
      <span className="box-label">వ్యూహాత్మక ప్రాముఖ్యత</span>
      భారత-అమెరికా సంబంధాలు వ్యాపారిక భాగస్వామ్యం వైపు వేగంగా మారుతున్నాయి. ట్రంప్ పాలనలో "అమెరికా ఓపెన్ ఫర్ బిజినెస్" విధానం మరియు భారత్ యొక్క "విక్సిత్ భారత్" దార్శనికత — ఈ రెండూ కలిసి వస్తున్నాయి. US Commerce Dept. ఈ సమ్మిట్‌ను <span>"SelectUSA చరిత్రలో భారత్ నుండి అతిపెద్ద పెట్టుబడి ప్రకటన"</span> అని అభివర్ణించింది.
    </div>

    <div className="divider"></div>

    <h2 className="sec-head"><TbTargetArrow  className='special-icon' /> ముగింపు: ఒక చారిత్రక పరివర్తన</h2>

    <p className="body-para">2026 SelectUSA సమ్మిట్ భారత్ యొక్క ఆర్థిక పరిపక్వతను ప్రపంచానికి స్పష్టంగా చాటింది. STL యొక్క AI ఫైబర్ పెట్టుబడి నుండి Sun Pharma యొక్క చారిత్రక సంపాదన వరకు, భారత కంపెనీలు ఇప్పుడు అమెరికన్ ఉద్యోగాలు సృష్టిస్తున్నాయి, అమెరికన్ ఆర్థిక వ్యవస్థలో భాగస్వాములవుతున్నాయి.</p>

    <p className="body-para">అయితే, పాఠకులు గమనించవలసిన విషయం ఏమిటంటే — ఈ పెట్టుబడులన్నీ భవిష్యత్ ప్రణాళికలు మరియు ప్రకటనలు. వాటి అమలు, నియంత్రణ అనుమతులు, మార్కెట్ పరిస్థితులు — ఇవన్నీ తుది ఫలితాలను నిర్ణయిస్తాయి. అయినప్పటికీ, ఈ పరిమాణం మరియు వేగం — భారత్ గ్లోబల్ పవర్‌హౌస్‌గా మారే దిశలో ఒక స్పష్టమైన సంకేతం.</p>

    <div className="pullquote">
      <p>"భారత్ మరియు అమెరికా — ప్రపంచంలో అతిపెద్ద ప్రజాస్వామ్యాలు వ్యాపారం చేసినప్పుడు, అందరూ గెలుస్తారు."</p>
      <cite>— US Ambassador Sergio Gor</cite>
    </div>

    <div className="refs">
      <h5><SiBookstack className='special-icon' /> సూచనలు మరియు ఆధారాలు (References)</h5>
      <ol>
        <li>PRNewswire — STL $100M US Investment Announcement, May 8, 2026</li>
        <li>US Embassy India — Record $20.5 Billion Indian Investments at SelectUSA 2026</li>
        <li>US Embassy India — FACTSHEET: Indian Investments at 2026 SelectUSA Investment Summit</li>
        <li>BusinessToday — Sun Pharma to acquire Organon in $11.75 billion all cash deal, April 27, 2026</li>
        <li>Organon &amp; Co. / SEC Form 8-K — Definitive Agreement, April 26, 2026</li>
        <li>Manufacturing Dive — India-based companies announce record $20B worth of US investments, May 8, 2026</li>
        <li>ANI / Tribune India — Indian companies pledge record USD 20.5 billion investment in US, May 6, 2026</li>
        <li>Communications Today — STL to invest $100M in US for AI, data centre growth, May 2026</li>
        <li>BW Businessworld — Sterlite Technologies to Invest Up To $100 Mn to Expand US Manufacturing Capacity</li>
        <li>US Bureau of South and Central Asian Affairs (SCA) — Official X/Twitter posts, May 6, 2026</li>
      </ol>
    </div>

    <div className="footer-tagline">
      ఈ విశ్లేషణ మీకు నచ్చినట్లయితే, దయచేసి మా పోర్టల్‌ను అనుసరించండి, మీ స్నేహితులతో పంచుకోండి, అలాగే మీ విలువైన అభిప్రాయాలను తెలియజేయండి.
    </div>

  </div>
                     </div>
                      }



                  {!singleNews && error &&    <div className='container-fluid g-0'>
                                 <div className='row g-0'>
                                 <div className='col-12'>
                              <div className="json-loading-error-div mt-2">
                                <img  src={`${import.meta.env.BASE_URL}assets/images/json_error.png`} alt="json_error" />
                              </div>
                          </div>
                          </div>
                            </div>
                   }

      </div>

    </>
    
  );
};



const GetTheFullDescContent = ({ data }) => {
  const baseURL = "https://www.teluguone.com";
  const containerRef = useRef(null);

  // Replace relative URLs
  const fixedData = useMemo(() => {
    if (!data) return '';
    return data
      .replace(/src="\/teluguoneUserFiles/g, `src="${baseURL}/teluguoneUserFiles`)
      .replace(/src="\/tonecmsuserfiles/g, `src="${baseURL}/tonecmsuserfiles`);
  }, [data]);

 
  return (
    <div className="news-content-main-box" ref={containerRef}>
      <div className="news-content-main-one-description" dangerouslySetInnerHTML={{__html : fixedData ?  he.decode(fixedData) : '' }}>
      </div>
    </div>
  );
};





export default NewsContentMain;
